import '../styles.css';
import {useState} from 'react';
import EnterMobile from './EnterMobile';
import EnterCode from './EnterCode';

const Index = () => {
    const stateComponent = {
      'ENTER_MOBILE' : EnterMobile,
      'ENTER_CODE' : EnterCode,
    };

    const [status, setStatus] = useState('ENTER_MOBILE');

    const goToNext = () => {
        setStatus('ENTER_CODE');
    }

    const [mobile, setMobile] = useState('');

    const getRightComponent = () => {
        let Component = stateComponent[status];
        return <Component mobile={mobile} setMobile={setMobile} goToNext={goToNext}/>
    }

    return (
        <>
            {getRightComponent()}
        </>
    )
}

export default Index;
